//@ts-nocheck
/*
 *  This file http-service.ts is part of HROne Inbox. The intelectual property owned by Uneecops Workplace Solution PVT. LTD.
 *  CopyrightYear: 2025
 *  (C) 2015-2025. All Right reserved. Uneecops Workplace Solution PVT. LTD.
 *
 */

import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ServerErrorHandler } from './error-handler/server-error-handler.service';
import { ConfigurationService } from './configuration.service';
import { SnackbarAlertService } from './snackbar-alert.service';

@Injectable()
export class HttpService {

  constructor(
    private readonly _httpClient: HttpClient,
    private readonly _serverError: ServerErrorHandler,
    public _config: ConfigurationService,
    public _snackBar: SnackbarAlertService
  ) { }

  getHeadersUnauthorized() {
    const dcStr = localStorage.getItem('domainCode');
    const dc: string = dcStr ?? this._config.domainCode;
    return new HttpHeaders({
      'Content-Type': 'application/json',
      'domainCode': dc,
      'AccessMode': 'W'
    });

  }

  getHeadersUnauthorizedWithAppId(apiKey: string, domainCode: string, skipWithCredital:boolean): HttpHeaders {
    return new HttpHeaders({
      'domainCode': domainCode,
      'apiKey': apiKey,
      'AccessMode': 'W',
      'skip-withcredentials': skipWithCredital ? 'true' : 'false'
    });

  }
  getHeadersUnauthorizedWithAppIdIfCaptcha(apiKey: string, domainCode: string, skipWithCredital:boolean, captcha: string) {
    return new HttpHeaders({
      'domainCode': domainCode,
      'apiKey': apiKey,
      'AccessMode': 'W',
      'g-Recaptcha-Response': captcha,
      'skip-withcredentials': skipWithCredital ? 'true' : 'false'
    });

  }

  getHeadersForFileUpload() {
    const dcStr = localStorage.getItem('domainCode');
    const dc: string = dcStr ?? this._config.domainCode;

    return new HttpHeaders({
      'domainCode': dc,
      'AccessMode': 'W'
    });
  }

  handleServerError(err) {
    return throwError(err);
  }

  PutUnauthorizedWithAppId(url, appId, domainCode, param, skipWithCredital = false): Observable<any> {
    const headers = this.getHeadersUnauthorizedWithAppId(appId, domainCode,skipWithCredital);
    return this._httpClient.put(this._config.microservice_base_url + url, param, { headers: headers })
      .pipe(
        catchError(err =>
          this._serverError.handleServerError(err)
        )
      );
  }
  oldPutUnauthorizedWithAppId(url, appId, domainCode, param): Observable<any> {
    const headers = this.getHeadersUnauthorizedWithAppId(appId, domainCode,true);
    return this._httpClient.put(this._config.base_url + url, param, { headers: headers })
      .pipe(
        catchError(err =>
          this._serverError.handleServerError(err)
        )
      );
  }

  public PostUnAuthorize(url, param): Observable<any> {
    const headers = this.getHeadersUnauthorized();
    return this._httpClient.post(this._config.base_url + url, param, { headers: headers })
      .pipe(
        catchError(err =>
          this._serverError.handleServerError(err, 'isUnauthorize')
        )
      );
  }

  public PostMicroserviceUnAuthorize(url, param, responseType = 'json'): Observable<any> {
    const headers = this.getHeadersUnauthorized();
    return this._httpClient.post(this._config.microservice_base_url + url, param, { headers, responseType })
      .pipe(
        catchError(err =>
          this._serverError.handleServerError(err, 'isUnauthorize')
        )
      );
  }

  public PostUnauthorizedWithAppId(url, appId, domainCode, param,  skipWithCredital = false,  captcha?: string): Observable<any> {
    const headers = captcha ? this.getHeadersUnauthorizedWithAppIdIfCaptcha(appId, domainCode, skipWithCredital, captcha) : this.getHeadersUnauthorizedWithAppId(appId, domainCode, skipWithCredital);
    return this._httpClient.post(this._config.microservice_base_url + url, param, { headers: headers })
      .pipe(
        catchError(err =>
          this._serverError.handleServerError(err, 'isUnauthorize')
        )
      );
  }
  public oldPostUnauthorizedWithAppId(url, appId, domainCode, param,  captcha?: string): Observable<any> {
    const headers = captcha ? this.getHeadersUnauthorizedWithAppIdIfCaptcha(appId, domainCode, true, captcha) : this.getHeadersUnauthorizedWithAppId(appId, domainCode, true);
    return this._httpClient.post(this._config.base_url + url, param, { headers: headers })
      .pipe(
        catchError(err =>
          this._serverError.handleServerError(err, 'isUnauthorize')
        )
      );
  }

  public GetWithoutHeader(url): Observable<any> {
    return this._httpClient.get(this._config.base_url + url)
      .pipe(
        catchError(err =>
          this._serverError.handleServerError(err)
        )
      );
  }

  public GetUnauthorizedWithAppId(url, apiKey, domainCode, skipWithCredital = false ,captcha?: string): Observable<any> {
    const headers = captcha ? this.getHeadersUnauthorizedWithAppIdIfCaptcha(apiKey, domainCode,skipWithCredital ,captcha) : this.getHeadersUnauthorizedWithAppId(apiKey, domainCode, skipWithCredital);
    return this._httpClient.get(this._config.microservice_base_url + url, { headers: headers })
      .pipe(
        catchError(err =>
          this._serverError.handleServerError(err)
        )
      );
  }

  oldGetUnauthorizedWithAppId(url, apiKey, domainCode,captcha?: string): Observable<any> {
    const headers = captcha ? this.getHeadersUnauthorizedWithAppIdIfCaptcha(apiKey, domainCode,true ,captcha) : this.getHeadersUnauthorizedWithAppId(apiKey, domainCode, true);
    return this._httpClient.get(this._config.base_url + url, { headers: headers })
      .pipe(
        catchError(err =>
          this._serverError.handleServerError(err)
        )
      );
  }

  public PostFileUpload(url, param): Observable<any> {
    const headers = this.getHeadersForFileUpload();
    headers.delete('Accept');
    return this._httpClient.post(this._config.microservice_base_url + url, param,
      { headers: headers })
      .pipe(catchError((err: HttpErrorResponse) => {
        if (err.status === 400 && err.url.includes('api/File/UploadUserFile')) {
          let allError = '';
          if (err.error?.File) {
            err.error?.File?.forEach(element => {
              allError = element + allError;
            });
          }
          if (err.error?.EmployeeCode) {
            err.error?.EmployeeCode?.forEach(element => {
              allError = element + allError;
            });
          }
          if (err.error?.FolderId) {
            err.error?.FolderId?.forEach(element => {
              allError = element + allError;
            });
          }
          this._snackBar.Alert(allError, '2');
          return throwError(err);
        } else {
          this._serverError.handleServerError(err);
        }
      }
      ));
  }

  public PostExternalFile(url, apiKey, domainCode, param, skipWithCredital = false): Observable<any> {
    const headers = this.getHeadersUnauthorizedWithAppId(apiKey, domainCode, skipWithCredital);
    headers.delete('Accept');
    return this._httpClient.post(this._config.base_url + url, param,
      { headers: headers })
      .pipe(catchError(err => this._serverError.handleServerError(err)));
  }
  public oldPostExternalFile(url, apiKey, domainCode, param): Observable<any> {
    const headers = this.getHeadersUnauthorizedWithAppId(apiKey, domainCode, true);
    headers.delete('Accept');
    return this._httpClient.post(this._config.base_url + url, param,
      { headers: headers })
      .pipe(catchError(err => this._serverError.handleServerError(err)));
  }
}